import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import mediaSlices, { type MediaSlices } from './slices';

const devtoolsInstance = devtools(mediaSlices, { name: 'useMediaStore' });

const useMediaStore = create<MediaSlices, [['zustand/devtools', never]]>(devtoolsInstance);

export default useMediaStore;
